import axios from '../../axios';

//加载头文件
//import * as StkInProductReturnEntryApi from './moudules/stk/StkInProductReturnEntryApi'; //产成品退货单明细
//  StkInProductReturnEntryApi,//产成品退货单明细

// 产成品退货单明细列表
export const getStkInProductReturnEntryPage = data => {
return axios({
url: '/api/sys/stk/getStkInProductReturnEntryPage',
method: 'post',
data
})
};

// 产成品退货单明细保存
export const saveStkInProductReturnEntry = data => {
return axios({
url: '/api/sys/stk/saveStkInProductReturnEntry',
method: 'post',
data
})
};

// 产成品退货单明细修改
export const updateStkInProductReturnEntry = data => {
return axios({
url: '/api/sys/stk/updateStkInProductReturnEntry',
method: 'post',
data
})
};

// 产成品退货单明细删除
export const deleteStkInProductReturnEntry = data => {
return axios({
url: '/api/sys/stk/deleteStkInProductReturnEntry',
method: 'post',
data
})
};

// 产成品退货单明细查单条
export const getStkInProductReturnEntry = data => {
return axios({
url: '/api/sys/stk/getStkInProductReturnEntry',
method: 'post',
data
})
};




// WEBPACK FOOTER //
// ./src/api/moudules/stk/StkInProductReturnEntryApi.js